import api from '@pray/shared/utils/api';

import type { SmsConfig } from './types';

type EnableSmsProps = {
  artistId: string;
};

export async function enableSms({ artistId }: EnableSmsProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/sms-config/enable`;

  const response = await api.executePostRequest<{ data: SmsConfig }>(url);

  return response.data;
}
